import { render } from "./publish.vue?vue&type=template&id=6ac4796c&scoped=true"
import script from "./publish.vue?vue&type=script&lang=js"
export * from "./publish.vue?vue&type=script&lang=js"

import "./publish.vue?vue&type=style&index=0&id=6ac4796c&scoped=true&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ac4796c"]])

export default __exports__